<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <div class="header">
      @if (objectIcon) {
        <fa-icon [icon]="objectIcon"></fa-icon>
      }
      <h2 ngpDialogTitle>{{ objectTitle }}</h2>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <app-alert-editor #alertEditor [alert]="alert"></app-alert-editor>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button size="sm" variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>

    <sui-button
      size="sm"
      variant="primary"
      [disabled]="!isValid()"
      (click)="save()"
    >
      {{ "btn.save" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
